/* import { useState } from 'react' */
import styled from 'styled-components/macro'

import DiceBet from './components/DiceBet'

const PageWrapper = styled.div`
  max-width: 900px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 500px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 400px;
    margin-top: 5rem;
  `};
`

function Dice() {
  return (
    <PageWrapper>
      <DiceBet />
    </PageWrapper>
  )
}

export default Dice
